import React from 'react';
import HeaderCell from './HeaderCell';
import classNames from 'classnames';
import { HEADER_CELL_ICON_PROPS } from './Types';
import WithTooltip from '../../../utility/withTooltip';
import PuzzleTooltip from '../../UI/tooltip/PuzzleTooltip';

class HeaderCellIcon extends HeaderCell<HEADER_CELL_ICON_PROPS, {}> {
  tooltip: any = null;

  renderInnerCell = () => {
    const {
      headerCellConfig = {}
    } = this.props;
    const { icon, toolTipText } = headerCellConfig;
    const className = classNames('tp-icon', icon);

    if (toolTipText) {
      return (
        <>
          <WithTooltip
            context={this}
            title={toolTipText}
            htmlTag={'span'}
          >
            <span
              tabIndex={0}
              title={toolTipText} 
              className={className}
            />
          </WithTooltip>
          <PuzzleTooltip
            anchorElement={'target'}
            ref={(el: any) => this.tooltip = el}
            position={'bottom'}
          />
        </>
      );
    } else {
      return (
        <span className={className} />
      );
    }
  };
}

export default HeaderCellIcon;
